import React from 'react'
import KnowledgeCell from './KnowledgeCell'
import { KnowledgeModel } from '../../../model/knowledge.model'
import './KnowledgeList.css'
interface KnowledgeList {
    dataSource?: KnowledgeModel[]
    isDeletting?: boolean
    className?: string
    onItemClick?: (knowledge: KnowledgeModel) => void
}
const KnowledgeList: React.FC<KnowledgeList> = (props) => {
    const {
        dataSource = [],
        isDeletting,
        className = '',
        onItemClick = (knowledge: KnowledgeModel) => undefined,
    } = props
    return (
        <div className={`knowledge-list ${className}`}>
            {dataSource.map((item) => (
                <KnowledgeCell
                    key={item.k_id}
                    title={item.k_title}
                    deleteable={isDeletting}
                    answer={item.KAnswers[0] && item.KAnswers[0].k_answer}
                    onClick={() => {
                        onItemClick(item)
                    }}
                />
            ))}
        </div>
    )
}

export default KnowledgeList
